import { Nav } from './styles';

function Navbar() {
  return (
    <Nav></Nav>
  );
};

export default Navbar;
